
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Text } from 'office-ui-fabric-react';

const classNames = mergeStyleSets({
    labelBox: {
        padding: '1em 0em',
        display: 'flex',
        justifyContent: 'space-between'
    },

    quanBox: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '1em'
    }
})

const Modification = ({
    quantity,
    modification,
    operationList
}) => {

    return (
        <Stack>
            <Stack.Item className={classNames.labelBox}>
                <Text variant={'smallB'}>Úprava: {modification.title}</Text>
            </Stack.Item>
            <Stack.Item>
                {operationList}
            </Stack.Item>
        </Stack>
    );
}

export default Modification;
